import { LayoutComponent } from '../layout/layout.component';
import { LoginComponent } from './pages/login/login.component';
import { resetPasswordComponent } from './pages/resetPassword/resetPassword.component';
import { changePasswordComponent } from './pages/changePassword/changePassword.component';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';
import { AuthGuard } from '../shared/authentication/auth.guard';
import {UberAdminLayoutComponent} from "../layout/uber-admin-layout/uber-admin-layout.component";
import {DashboardComponent} from "./dashboard/dashboard.component";

export const routes = [
    {
        path: 'uberadmin',
        component: UberAdminLayoutComponent,
        children: [
              { path: 'home', redirectTo: 'organizations', canActivate: [AuthGuard]},
              { path: 'organizations', loadChildren: './organizations/organizations.module#OrganizationsModule', canActivate: [AuthGuard] },
              { path: 'configuration', loadChildren: './configuration/configuration.module#ConfigurationModule', canActivate: [AuthGuard]}
            ],
        canActivate: [AuthGuard]
    },
    {
      path: 'admin',
      component: LayoutComponent,
      children: [
        { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
        { path: 'companies', loadChildren: './companies/companies.module#CompaniesModule', canActivate: [AuthGuard]},
        { path: 'users', loadChildren: './users/users.module#UsersModule', canActivate: [AuthGuard]},
        { path: 'equipment', loadChildren: './epis/epis.module#EpisModule', canActivate: [AuthGuard]},
        { path: 'workorders', loadChildren: './workorders/workorders.module#WorkordersModule', canActivate: [AuthGuard]},
        { path: '**', redirectTo: 'dashboard', canActivate: [AuthGuard]}
      ],
      canActivate: [AuthGuard]
    },

    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'login/reset', component: resetPasswordComponent },
    { path: 'login/change', component: changePasswordComponent },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },

    { path: '**', redirectTo: 'login'}
];



// WEBPACK FOOTER //
// ./src/app/routes/routes.ts